import React, { createContext, useContext, useEffect, useState } from "react";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [googlePhotosToken, setGooglePhotosToken] = useState(null);
  const [checkingAuth, setCheckingAuth] = useState(true);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/api/auth/me`,
          { credentials: "include" }
        );
        if (!res.ok) throw new Error("Not logged in");

        const data = await res.json();
        setUser(data.user || null);
      } catch (err) {
        console.warn("Not logged in:", err.message);
        setUser(null);
      } finally {
        setCheckingAuth(false);
      }
    };

    fetchUser();
  }, []);

  // Proactive Google token refresh every 30 minutes
  useEffect(() => {
    if (!user) return;

    const refreshGoogleToken = async () => {
      try {
        console.log("🔄 Proactive Google Photos token refresh...");
        const res = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/api/refresh-google-token`,
          { 
            method: "POST",
            credentials: "include" 
          }
        );
        
        if (res.ok) {
          console.log("✅ Google Photos token refreshed proactively");
        } else {
          console.warn("⚠️ Proactive token refresh failed:", res.status);
        }
      } catch (err) {
        console.warn("⚠️ Error during proactive token refresh:", err.message);
      }
    };

    // Refresh immediately on load, then every 30 minutes
    refreshGoogleToken();
    const interval = setInterval(refreshGoogleToken, 30 * 60 * 1000);

    return () => clearInterval(interval);
  }, [user]);

  const value = {
    user,
    setUser,
    googlePhotosToken,
    setGooglePhotosToken,
    checkingAuth,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
